(function () {
  'use strict';

  var DEBUG = (window.location.href.indexOf('preview_theme_id') > -1);
  function dlog() {
    if (!DEBUG) return;
    try { console.log.apply(console, ['[GND size-chart]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  var KEYWORDS = [
    /beden tablosunu/i,
    /beden tablosu/i,
    /size chart/i,
    /size guide/i
  ];

  var KIWI_TRIGGER_SELECTORS = [
    'button[class*="kiwi"]',
    'a[class*="kiwi"]',
    '[class*="kiwi-sizing"] button, [class*="kiwi-sizing"] a',
    '[class*="kiwi-button"]',
    '[class*="kiwi-trigger"]',
    '[class*="kiwi-size"]',
    '[class*="kiwi-recommender"]',
    '[id*="kiwi"] button, [id*="kiwi"] a'
  ];

  var KIWI_TEXT_HINTS = ['size chart', 'size guide', 'beden tablosu', 'beden ölçüsü'];

  function findKiwiTrigger() {
    for (var i = 0; i < KIWI_TRIGGER_SELECTORS.length; i++) {
      var sel = KIWI_TRIGGER_SELECTORS[i];
      var matches = document.querySelectorAll(sel);
      dlog('selector', sel, 'matched', matches.length);
      for (var j = 0; j < matches.length; j++) {
        var el = matches[j];
        if (el.closest('.gnd-size-chart-trigger')) continue;
        if (el.offsetParent === null && el.getClientRects().length === 0) continue;
        dlog('trigger picked from', sel, el);
        return el;
      }
    }
    var allClickables = document.querySelectorAll('button, a, [role="button"]');
    for (var k = 0; k < allClickables.length; k++) {
      var c = allClickables[k];
      if (c.closest('.gnd-size-chart-trigger')) continue;
      var txt = (c.textContent || '').trim().toLowerCase();
      if (!txt) continue;
      for (var h = 0; h < KIWI_TEXT_HINTS.length; h++) {
        if (txt === KIWI_TEXT_HINTS[h] || (txt.length < 30 && txt.indexOf(KIWI_TEXT_HINTS[h]) !== -1)) {
          dlog('trigger picked via text-hint', KIWI_TEXT_HINTS[h], c);
          return c;
        }
      }
    }
    dlog('no trigger found');
    return null;
  }

  function fallbackScroll() {
    var section = document.querySelector('[id*="kiwi"]')
      || document.querySelector('[class*="kiwi"]')
      || document.querySelector('.shopify-app-block');
    if (section && typeof section.scrollIntoView === 'function') {
      dlog('fallback scroll → ', section);
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      dlog('fallback scroll: no target found');
    }
  }

  function triggerKiwi(e) {
    if (e) e.preventDefault();
    var trigger = findKiwiTrigger();
    if (trigger) {
      try { trigger.click(); dlog('clicked trigger'); return; } catch (err) { dlog('click threw', err); }
    }
    fallbackScroll();
  }

  function makeSpan(text) {
    var span = document.createElement('span');
    span.className = 'gnd-size-chart-trigger';
    span.setAttribute('role', 'button');
    span.setAttribute('tabindex', '0');
    span.textContent = text;
    span.addEventListener('click', triggerKiwi);
    span.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter' || ev.key === ' ') {
        triggerKiwi(ev);
      }
    });
    return span;
  }

  function wrapKeywordIn(textNode) {
    var text = textNode.nodeValue;
    for (var i = 0; i < KEYWORDS.length; i++) {
      var match = text.match(KEYWORDS[i]);
      if (!match) continue;
      var idx = match.index;
      var matched = match[0];
      var before = text.substring(0, idx);
      var after = text.substring(idx + matched.length);

      var parent = textNode.parentNode;
      if (!parent) return false;

      var span = makeSpan(matched);
      if (before) parent.insertBefore(document.createTextNode(before), textNode);
      parent.insertBefore(span, textNode);
      if (after) parent.insertBefore(document.createTextNode(after), textNode);
      parent.removeChild(textNode);
      return true;
    }
    return false;
  }

  function scanContainer(container) {
    if (container.dataset.gndSizeChartScanned === 'true') return;
    container.dataset.gndSizeChartScanned = 'true';

    var nodes = [];
    var walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          var p = node.parentNode;
          while (p && p !== container) {
            if (p.classList && p.classList.contains('gnd-size-chart-trigger')) return NodeFilter.FILTER_REJECT;
            p = p.parentNode;
          }
          for (var i = 0; i < KEYWORDS.length; i++) {
            if (KEYWORDS[i].test(node.nodeValue)) return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_REJECT;
        }
      },
      false
    );

    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(wrapKeywordIn);
  }

  function init() {
    var containers = document.querySelectorAll('.toggle__content');
    for (var i = 0; i < containers.length; i++) scanContainer(containers[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
